import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { Response, Headers } from '@angular/http';
import { Config } from './config';
import { RestClientService } from './restclient.service';
import { Contrato } from '../modelo/contrato';
import { Parcela } from '../modelo/parcela';
import { Boleto, LiquidacaoContratoRequest, LiquidacaoParcelaRequest } from '../modelo/boleto';
import { SessaoService } from './sessao.service';
import { Cliente } from '../modelo/cliente';

@Injectable()
export class LiquidacaoAntecipadaService {

    constructor(
        private restClient: RestClientService,
        private sessaoService: SessaoService
    ) {

    }

    recuperarTipoContrato = (): Observable<Cliente> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/recuperarTipoContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    listarContrato = (cliente: Cliente): Observable<Cliente> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/listarContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/tpContrato/" + cliente.indcdTipoContrato;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    confirmarContrato = (contrato: Contrato): Observable<Contrato> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/confirmarContrato";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        resourcePath += "/tpContrato/" + contrato.tpContrato;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    efetivarLiquidacaoContrato = (contrato: Contrato): Observable<Boleto> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/efetivarLiquidacaoContratoPost";
        const request: LiquidacaoContratoRequest = {
          nuCTRL: this.sessaoService.sessao.autenticado.nuCTRL,
          nuContrato: contrato.nuContrato.toString(),
          vrTotalSaldoDevedor: contrato.contratoValor.vrTotalSaldoDevedor.toString()
        };
      return this.restClient.postResource(resourcePath, request);
    };

    listarParcela = (contrato: Contrato): Observable<Contrato> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/listarParcela";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        resourcePath += "/tpContrato/" + contrato.tpContrato;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    confirmarParcela = (contrato: Contrato): Observable<Contrato> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/confirmarParcela";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        resourcePath += "/qtParcelasAbertas/" + contrato.qtParcelasAbertas;
        resourcePath += "/cdOrdemParcelasAbertas/" + contrato.cdOrdemParcelasAbertas;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    efetivarLiquidacaoParcela = (contrato: Contrato): Observable<Boleto> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/efetivarLiquidacaoParcelaPost";
        const request: LiquidacaoParcelaRequest = {
          nuCTRL: this.sessaoService.sessao.autenticado.nuCTRL,
          nuContrato: contrato.nuContrato.toString(),
          qtParcelasAbertas: contrato.qtParcelasAbertas.toString(),
          cdOrdemParcelasAbertas: contrato.cdOrdemParcelasAbertas,
          vrTotalMulta: contrato.contratoValor.vrTotalMulta,
          vrTotalMora: contrato.contratoValor.vrTotalMora,
          vrTotalDesconto: contrato.contratoValor.vrTotalDesconto,
          vrTotalAtualizado: contrato.contratoValor.vrTotalAtualizado,
          vrTotalEncargosRemu: contrato.contratoValor.vrTotalEncargosRemu,
          vrTotalEncargosMora: contrato.contratoValor.vrTotalEncargosMora,
          nuCalculo: contrato.nuCalculo
        };
      return this.restClient.postResource(resourcePath, request);
    };

    recuperarDadosBoletoRegistrado = (boleto: Boleto, contrato: Contrato): Observable<Boleto> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/recuperarDadosBoletoRegistrado";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuBoleto/" + boleto.nuBoleto;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    recuperarDadosBoletoNaoRegistrado = (boleto: Boleto): Observable<Boleto> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/recuperarDadosBoletoNaoRegistrado";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuBoleto/" + boleto.nuBoleto;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    verificarSeguroPrestamista = (contrato: Contrato): Observable<any> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/verificarSeguroPrestamista";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        resourcePath += "/nuContrato/" + contrato.nuContrato;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    listarBanco = (): Observable<any> => {
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/listarBanco";
        resourcePath += "/nuCTRL/" + this.sessaoService.sessao.autenticado.nuCTRL;
        return this.restClient.getResource(resourcePath).map(response => response.json());
    };

    validarDadosClienteSeguro = (dadosCliente: any): Observable<any> => {
        dadosCliente.cdEtapa = 1;
        dadosCliente.nuCTRL = this.sessaoService.sessao.autenticado.nuCTRL;
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/cadastrarDadosClienteSeguro";
        return this.restClient.postResource(resourcePath, dadosCliente)
    };

    cadastrarDadosClienteSeguro = (dadosCliente: any): Observable<any> => {
        dadosCliente.cdEtapa = 2;
        dadosCliente.nuCTRL = this.sessaoService.sessao.autenticado.nuCTRL;
        let resourcePath = Config.LIQUIDACAOANTECIPADA_PATH + "/cadastrarDadosClienteSeguro";
        return this.restClient.postResource(resourcePath, dadosCliente)
    };    
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/liquidacaoantecipada.service.ts